module.exports = __webpack_public_path__ + "img/part-2-title.603f2d8c.png";